import React from "react";
import { motion } from "framer-motion";
import { Award, Star, ShieldCheck, Trophy } from "lucide-react";

const awards = [
  { icon: Trophy, title: "Best Corporate Gifting Solutions", by: "Corporate Excellence Awards" },
  { icon: Star, title: "Top 10 Gifting Partners", by: "Brand Leadership India" },
  { icon: ShieldCheck, title: "Great Place to Work® Certified", by: "High-performance culture" },
  { icon: Award, title: "Leading Supplier of Branded Merchandise", by: "Global Business Review" },
];

const BrandStory = () => {
  return (
    <section id="about" className="relative z-10 scroll-mt-28 overflow-hidden bg-[#0B0F19] py-24 md:py-32" data-testid="brand-story-section">
      <div className="pointer-events-none absolute left-1/2 top-0 h-[420px] w-[720px] -translate-x-1/2 bloom-indigo opacity-40" />
      <div className="mx-auto max-w-4xl px-6 text-center md:px-10">
        <motion.span
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="font-sans text-xs uppercase tracking-[0.3em] text-[#D4AF37]"
        >
          Our heritage
        </motion.span>
        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="mx-auto mt-5 max-w-3xl font-serif text-4xl leading-[1.1] tracking-tight text-[#F3EEE3] md:text-5xl"
        >
          Redefining corporate gifting in India{" "}
          <span className="italic text-[#D4AF37]">since 1999</span>
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.1 }}
          className="mx-auto mt-7 max-w-2xl font-sans text-base leading-relaxed text-[#A9B0C2]"
        >
          Powered by Consortium Gifts — one of Asia’s most innovative gifting companies.
          For over 26 years we&rsquo;ve delivered millions of gifts for Fortune 2500 giants,
          global enterprises and India’s fastest-growing startups, built on Quality,
          Innovation and Service.
        </motion.p>
      </div>

      <div className="mx-auto mt-16 grid max-w-6xl grid-cols-1 gap-5 px-6 sm:grid-cols-2 md:px-10 lg:grid-cols-4">
        {awards.map((a, i) => {
          const Icon = a.icon;
          return (
            <motion.div
              key={a.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.55, delay: (i % 4) * 0.08 }}
              className="flex flex-col items-center rounded-xl border border-[#F3E5AB]/10 bg-[#111826] p-7 text-center transition-colors duration-300 hover:border-[#D4AF37]/40"
              data-testid={`award-${i}`}
            >
              <Icon className="h-7 w-7 text-[#D4AF37]" strokeWidth={1.4} />
              <h3 className="mt-4 font-sans text-sm font-semibold leading-snug text-[#F3EEE3]">{a.title}</h3>
              <p className="mt-2 font-sans text-xs text-[#8B93A7]">{a.by}</p>
            </motion.div>
          );
        })}
      </div>
    </section>
  );
};

export default BrandStory;
